// extracted by mini-css-extract-plugin
export default {"td":"ServicosIndex_td__-6QAg"};